import { clone as _clone } from 'lodash';

export function formatPhone(phone: string): string {
  const plain = phone.replace(/\D/g, '');


  if (plain.length === 10) {
    return phone.replace(/(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
  }

  return plain.replace(/(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
}

export function formatCpf(value: string): string {
  const plain = value.replace(/[^0-9xX]/g, '');

  if (plain.length < 11) {
    return plain;
  }

  return plain.replace(/([Xx\d]{3})([Xx\d]{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
}

export const clone = _clone;
